import { apiRoutes } from 'routes';
import FetchHelpers from 'utils/FetchHelpers';

export default {
  index(params) {
    const path = apiRoutes.templatesMultiSheetPath();
    return FetchHelpers.get(path, params);
  },
  show(templateId) {
    const path = apiRoutes.templatesMultiSheetPath(templateId);
    return FetchHelpers.get(path, templateId);
  },
  create(params) {
    const path = apiRoutes.templatesMultiSheetPath();
    return FetchHelpers.post(path, params);
  },
  update(templateId, params) {
    const path = apiRoutes.templateMultiSheetPath(templateId);
    return FetchHelpers.put(path, params);
  },
  partialUpdate(templateId, params) {
    const path = apiRoutes.templateMultiSheetPath(templateId);
    return FetchHelpers.patch(path, params);
  },
  delete(templateId) {
    const path = apiRoutes.templateMultiSheetPath(templateId);
    return FetchHelpers.delete(path);
  },
  adaptive(templateId, params) {
    const path = apiRoutes.adaptiveMultiSheetTemplatePath(templateId);
    return FetchHelpers.get(path, params);
  },
};
